import { PropsWithChildren } from "react";

// import Feedback from '../components/Feedback';
import styles from "./StartScreenBackground.module.css";

type Props = {
  hideBackground?: boolean;
};
const WizardBackground: React.FC<Props & PropsWithChildren> = (props) => {
  return (
    <div
      className={`${
        props.hideBackground ? styles.BackgroundWithoutImage : styles.BackgroundWithImage
      } ${styles.Background}`}
    >
      {props.children}
    </div>
  );
};

export default WizardBackground;
